import { render, staticRenderFns } from "./BookingEmailWrapper.vue?vue&type=template&id=d6bbe5dc"
import script from "./BookingEmailWrapper.vue?vue&type=script&lang=js"
export * from "./BookingEmailWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports